/* eslint camelcase: 0 */ //
export default {
	development: {
		app_name: 'talentsarena',
		default_theme: 'light',
		base_url: 'http://localhost:8000',
		api_url: 'http://localhost:8000',
		backoffice_portal_url: process.env.REACT_APP_BACKOFFICE_PORTAL_URL,
		hiring_portal_url: process.env.REACT_APP_HIRING_PORTAL_URL,
		access_token_field_name: 'access_token',
		referesh_token_field_name: 'referesh_token',
		defaultExpandScreenSize: 'md',
		defaultPageSize: 10,
		kashierIframeURL: 'https://checkout.kashier.io/kashier-checkout.js',
		paymentWebhookUrl: ' https://6013-197-61-252-214.eu.ngrok.io/packages/purchase/hook/kashier',
		paymentRedirectUrl: 'http://localhost:3000/dashboard/job-board',
		paymentMode: 'test',
		companyName: 'Tech Arena for IT',
		companyAddress: '1 Dr. Mohamed Sobhy St., Giza, Second Floor, Giza, 12511',
		accountNumber: '100040858948',
		swiftCode: 'CIBEEGCX002',
		currency: 'Egyptian Pound',
		branch: 'AlHammad - New Cairo'
	},
	testing: {
		app_name: 'talentsarena',
		default_theme: 'light',
		base_url: 'https://3.136.86.75/api',
		api_url: 'https://3.136.86.75/api',
		backoffice_portal_url: process.env.REACT_APP_BACKOFFICE_PORTAL_URL,
		hiring_portal_url: process.env.REACT_APP_HIRING_PORTAL_URL,
		access_token_field_name: 'access_token',
		referesh_token_field_name: 'referesh_token',
		defaultExpandScreenSize: 'md',
		defaultPageSize: 10,
		kashierIframeURL: 'https://checkout.kashier.io/kashier-checkout.js',
		paymentWebhookUrl: 'https://3.136.86.75/api/packages/purchase/hook/kashier',
		paymentRedirectUrl: 'https://d1smlaw23ho4b7.cloudfront.net/dashboard/job-board',
		paymentMode: 'test',
		companyName: 'Tech Arena for IT',
		companyAddress: '1 Dr. Mohamed Sobhy St., Giza, Second Floor, Giza, 12511',
		accountNumber: '100040858948',
		swiftCode: 'CIBEEGCX002',
		currency: 'Egyptian Pound',
		branch: 'AlHammad - New Cairo'
	},
	staging: {
		app_name: 'talentsarena',
		default_theme: 'light',
		base_url: 'https://3.136.86.75/api',
		api_url: 'https://3.136.86.75/api',
		backoffice_portal_url: process.env.REACT_APP_BACKOFFICE_PORTAL_URL,
		hiring_portal_url: process.env.REACT_APP_HIRING_PORTAL_URL,
		access_token_field_name: 'access_token',
		referesh_token_field_name: 'referesh_token',
		defaultExpandScreenSize: 'md',
		defaultPageSize: 10,
		kashierIframeURL: 'https://checkout.kashier.io/kashier-checkout.js',
		paymentWebhookUrl: 'https://3.136.86.75/api/packages/purchase/hook/kashier',
		paymentRedirectUrl: 'https://d1smlaw23ho4b7.cloudfront.net/dashboard/job-board',
		paymentMode: 'test',
		companyName: 'Tech Arena for IT',
		companyAddress: '1 Dr. Mohamed Sobhy St., Giza, Second Floor, Giza, 12511',
		accountNumber: '100040858948',
		swiftCode: 'CIBEEGCX002',
		currency: 'Egyptian Pound',
		branch: 'AlHammad - New Cairo'
	},
	production: {
		app_name: 'talentsarena',
		default_theme: 'light',
		base_url: 'https://api.talentsarena.net',
		api_url: 'https://api.talentsarena.net',
		backoffice_portal_url: process.env.BACKOFFICE_PORTAL_URL,
		hiring_portal_url: process.env.HIRING_PORTAL_URL,
		access_token_field_name: 'access_token',
		referesh_token_field_name: 'referesh_token',
		defaultExpandScreenSize: 'md',
		defaultPageSize: 10,
		kashierIframeURL: 'https://checkout.kashier.io/kashier-checkout.js',
		paymentWebhookUrl: 'https://api.talentsarena.net/packages/purchase/hook/kashier',
		paymentRedirectUrl: 'https://hiring.talentsarena.net/dashboard/job-board',
		paymentMode: 'live',
		companyName: 'Tech Arena for IT',
		companyAddress: '1 Dr. Mohamed Sobhy St., Giza, Second Floor, Giza, 12511',
		accountNumber: '100040858948',
		swiftCode: 'CIBEEGCX002',
		currency: 'Egyptian Pound',
		branch: 'AlHammad - New Cairo'
	}
};
